import React from 'react';
import '../styles/layout.css';
import {
  numberFormat
} from '../utils/sales';


interface Props {
  data: IReportData
}

const TotalsKPI: React.FC<Props> = ({data}) => {
  return (
    <div className="grid-container grid-container-3">
      <div className="grid-item">
        <div className="kpi-container">
          <div className="text-18 text-gray">Revenue</div>
          <div className="text-24 font-bold text-gray mt-2">{
            numberFormat(
              data.total_revenue,
              'currency',
              'short',
              1
            )}
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="kpi-container">
          <div className="text-18 text-gray">Charges</div>
          <div className="text-24 font-bold text-gray mt-2">{
            numberFormat(
              data.total_charges,
              'currency',
              'short',
              1
            )}
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="kpi-container">
          <div className="text-18 text-gray">Adjustments</div>
          <div className="text-24 font-bold text-gray mt-2">{
            numberFormat(
              data.total_adjustment,
              'currency',
              'short',
              1
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalsKPI;
